var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1.48347C0.494225 0.989246 0.989267 0.494204 1.48347 0C3.66008 2.15189 5.83564 4.32766 7.98775 6.50427C10.1644 4.32766 12.3399 2.1521 14.5165 0L16 1.48347L9.49573 7.98775C11.6476 10.1644 13.8234 12.3399 16 14.5165L14.5165 16C12.3399 13.8234 10.1644 11.6478 7.98775 9.49573C5.83585 11.6476 3.66008 13.8234 1.48347 16C0.989246 15.5058 0.494204 15.0107 0 14.5165C2.15189 12.3399 4.32766 10.1644 6.50427 7.98775C4.32766 5.83585 2.1521 3.66008 0 1.48347Z","fill":"currentColor"}));
}

CloseIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
